<div *transloco="let t; read: 'profile-list-availability-filter'"
  class="filter-section">

  <!-- mat-form classes have been added to mimic the mat-label styling the other filter labels have -->
  <fieldset role="group"
    [attr.aria-label]="t('aria_availability')"
    class="mat-form-field-appearance-legacy">
    <legend class="mat-body-1 mat-form-field-label">{{ t('availability') }}</legend>

    @for (control of availabilityForm.controls | keyvalue; track control.key) {
      <accredible-checkbox-input size="large"
        color="accent"
        [formControlRef]="availabilityForm.controls[control.key]">
        {{ t(control.key) }}
      </accredible-checkbox-input>
    }
  </fieldset>

</div>
